// extracted by mini-css-extract-plugin
module.exports = {"paper":"Ln_ZIpOH-DeM","scroll":"JO0b3Ql-R46e","close":"_1S7oZsiNK9JB"};